import { render } from "./AboutSection.vue?vue&type=template&id=e56bd9e4"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nikidekor-frontend/nikidekor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__